module.exports = __webpack_public_path__ + "static/media/icon-en.c28f6fec.png";